import { type FC } from 'react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import sanitizeHtml from 'sanitize-html'

import { IntuitMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'

import Typography from '@segment/matcha/components/Typography'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import TestimonialBase, * as Testimonial from '@segment/matcha/recipes/Testimonial'

const testimonialData = {
  text: `“We're focused on using generative AI to interact with members to help answer their questions in a highly personalized way when shopping for financial products. Customers can interact, learn more, and ask questions to help make confident decisions.”`,
  caption: `Source: <a href="https://www.fool.com/earnings/call-transcripts/2024/02/22/intuit-intu-q2-2024-earnings-call-transcript/" target="_blank">Earnings call 2/22/24</a>`,
}
const IntuitTestimonial: FC = () => {
  const theme = useTheme()

  return (
    <Wrapper>
      <StyledSection variant="centered">
        <StyledTestimonialBase>
          <Testimonial.Base height="auto" tokens={{ background: theme.palette.twilio.gray[100] }}>
            <Testimonial.BaseContentSlot>
              <Testimonial.BaseLogo>
                <IntuitMonoLogo color={theme.palette.neutrals.white[100]} />
              </Testimonial.BaseLogo>
              <Testimonial.BaseText tokens={{ color: theme.palette.neutrals.white[100] }}>
                {testimonialData.text}
              </Testimonial.BaseText>
            </Testimonial.BaseContentSlot>
          </Testimonial.Base>
        </StyledTestimonialBase>
        <Description
          variant="pMedium"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(testimonialData.caption, { allowedTags: [`a`] }),
          }}
        />
      </StyledSection>
    </Wrapper>
  )
}

const StyledTestimonialBase = styled(TestimonialBase)`
  max-width: 1040px;
`

const StyledSection = styled(SectionBase)`
  max-width: 1200px; // 1040 + 80 + 80
  ${Section.Wrapper} {
    row-gap: 32px;
  }
`

const Wrapper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
  z-index: 0;
`

const Description = styled(Typography)`
  place-self: start;
  margin: 0;
  color: ${({ theme }) => theme.palette.twilio.gray[80]};
  a {
    font-weight: 600;
  }
`

export default IntuitTestimonial
